<template>
  <div>
    <TopNav />
    <div class="main-content">
      <!-- HEADER -->
      <div class="header">
        <div class="container">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-bind:route="'IncompleteCompletionDetail'" />
            </div>
          </div>
          <div class="container pt-5">
            <div class="row">
              <div class="col-12" v-if="exam_and_lesson_name[0] && exam_and_lesson_name[1]">
                <h2 class="text-muted"><router-link :to='{name: "IncompleteCompletion"}'>{{ exam_and_lesson_name[1] }}</router-link> <i class="fe fe-arrow-right"></i> <span class="text-primary">{{ exam_and_lesson_name[0] }}</span></h2>
              </div>
              <div class="col-12" v-if="message">
                <div class="alert alert-primary">{{ message }}</div>
              </div>
              <IncompleteCompletionSubjects :subject="subjects" :lesson_id="lesson_id" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav';
import Head from '@/components/Head';
import IncompleteCompletionSubjects from '@/components/IncompleteCompletionSubjects';
import base from '@/mixins/base'

export default {
  name: 'IncompleteCompletionDetail',
  components: { TopNav, Head, IncompleteCompletionSubjects },
  mixins: [ base ],
  data () {
    return {
      message: '',
      subjects: {},
      exam_id: this.$route.params.id,
      subject_id: this.$route.params.sub_id,
      lesson_id: 0,
      exams: {},
      exam_and_lesson_name: [null, null]
    }
  },
  created() {
    this.message = 'Yükleniyor...'
    setTimeout(() => {
      this.deviceTimeNConnectionCheck()
      if (this.$store.state.exam.incomplete_completion != null) {

        this.message = ''
        this.exams = this.$store.state.exam.incomplete_completion

      } else {

        this.$store.dispatch('exam/incompleteCompletion', this.$store.state.auth.student_id).then (
          exams => {
            this.exams = exams
            this.message = ''
          },
          error => {
            if (error.response !== undefined && error.response.data !== undefined && typeof error.response.data.message !== undefined) {
              this.message = error.response.data.message;
              return;
            } else {
              this.message = "Bir sorun oluştu."
            }
          }
        );
      }

      let found = false;
      let e = this.exams
      let json = {}
      e.forEach(exam => {

        if ( exam.id === this.exam_id) {
          
          json = exam.json;
          Object.entries(json).forEach(lesson => {
            if ( lesson[0] === this.subject_id ) {
              found = true
              this.lesson_id = lesson[1][0].ders_id
              this.subjects = lesson[1][0].soru_bilgileri
              this.exam_and_lesson_name = [lesson[1][0].ders_isim, exam.sinav_adi]
            }
          })

        }
      })

      if (! found) {
        this.message = 'Kayıt bulunamadı!'
      }
    }, 1500);
  }
}
</script>